/* eslint-disable no-unused-vars */
import { Mapper } from 'common/infrastructure/mapper';
import { ReferenceTableItemEntity } from '@planitgeo/treeplotter-domain/lib/modules/reference-table/reference-table/domain/reference-table-item.entity';
import { ReferenceTableItem } from 'api-client';

type ReferenceTableItemPersisted = Record<string, number | string | undefined | object>;

const toDTO = (referenceTableItem: ReferenceTableItemEntity): ReferenceTableItem => {
  throw new Error(
    'toDTO not implemented - ReferenceTableItem is now managed within ReferenceTable aggregate'
  );
};

const fromDTO = (data: ReferenceTableItem): ReferenceTableItemEntity => {
  // ReferenceTableItemEntity no longer has referenceTableId - it's managed by the parent ReferenceTable aggregate
  const { id, attributes, tp2LookupTableItemId } = data;
  return new ReferenceTableItemEntity({ id, attributes, tp2LookupTableItemId });
};

const toPersistence = (
  referenceTableItem: ReferenceTableItemEntity
): ReferenceTableItemPersisted => {
  throw new Error(
    'toPersistence not implemented - ReferenceTableItem is now managed within ReferenceTable aggregate'
  );
};

const notImplemented = () => {
  throw new Error('Not implemented');
};

export const ReferenceTableItemMapper: Mapper<ReferenceTableItemEntity, ReferenceTableItem> = {
  toDTO,
  fromDTO,
  toPersistence,
  fromPersistence: notImplemented,
};
